import Modal from "./segments/modal";
import { removeParameterFromUrl } from "../helpers/url";
import Container from './segments/container';
import ToggleButton from './segments/toggle-button';
import { createSegment } from "./segments/ajax";
import Instructions from "./segments/instructions";
import QueryParams from "./segments/query-params";
import { mapResponseSegmentToSegment } from "./segments/helpers";
var canManageSegments = function () {
    return ac_search.capabilities.user_can_manage_shared_segments;
};
var Segments = /** @class */ (function () {
    function Segments(table, search, sorting, whitelistedUrlParams) {
        // Dependencies
        this.Table = table;
        this.Search = search;
        this.Sorting = sorting;
        this.WhitelistedUrlParams = whitelistedUrlParams;
        this.ToggleButton = new ToggleButton(document.querySelector('.ac-button__segments'));
        this.Container = new Container(document.querySelector('.ac-segments'), canManageSegments());
        this.Modal = new Modal(document.querySelector('#ac-modal-create-segment'), this);
        // Initiation
        AdminColumns.Modals.register(this.Modal, 'create_segment');
        this.initEvents();
    }
    Segments.prototype.getCurrentState = function () {
        return {
            rules: JSON.stringify(this.Search.getRules()),
            sorting: JSON.stringify(this.Sorting)
        };
    };
    Segments.prototype.unsetCurrent = function () {
        var url = window.location.href;
        this.Container.setCurrent('');
        history.replaceState({}, '', removeParameterFromUrl(url, 'ac-segment'));
    };
    Segments.prototype.checkButtonStatus = function () {
        var button = document.querySelector('.ac-segments__create .button');
        var rules = JSON.parse(this.getCurrentState().rules);
        if (rules.rules.length === 0) {
            button.setAttribute('disabled', 'disabled');
        }
        else {
            button.removeAttribute('disabled');
        }
    };
    Segments.prototype.initEvents = function () {
        var _this = this;
        this.ToggleButton.events.on('open', function () {
            _this.Container.show();
            _this.Container.moveToElement(_this.ToggleButton.element);
        });
        this.ToggleButton.events.on('close', function () {
            _this.Container.hide();
        });
        this.Container.el.addEventListener('click', function (e) { return e.stopPropagation(); });
        document.addEventListener('click', function () {
            if (_this.ToggleButton.isOpen())
                _this.ToggleButton.triggerClose();
        });
        this.Modal.events.on('save', function (data) {
            var queryStringParams = new QueryParams(_this.Search);
            var global = !!data.get('global');
            _this.Modal.setLoading();
            createSegment(data.get('name').toString(), global, queryStringParams.get().toString(), _this.WhitelistedUrlParams.getWhitelistedParams(), AC.ajax_nonce, AC.layout)
                .then(function (response) {
                _this.Modal.setLoading(false);
                if (response.data.success) {
                    var segment = mapResponseSegmentToSegment(response.data.data.segment);
                    Segments.pushState(segment.getResponseItem());
                    _this.Container.refreshSegments(segment.getId().toString());
                    _this.Modal.finish();
                }
                else {
                    _this.Modal.displayError(response.data.data.error);
                }
            });
        });
        new Instructions('.ac-segments__instructions', '#ac-segments-instructions');
    };
    Segments.pushState = function (segment) {
        history.replaceState({}, segment.name, segment.url);
    };
    return Segments;
}());
export default Segments;
